import { render, staticRenderFns } from "./putOut.vue?vue&type=template&id=01496cac&scoped=true&"
import script from "./putOut.vue?vue&type=script&lang=js&"
export * from "./putOut.vue?vue&type=script&lang=js&"
import style0 from "./putOut.vue?vue&type=style&index=0&id=01496cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01496cac",
  null
  
)

export default component.exports